import style from "./style.css";
import { h } from "preact";
import { IStatus } from "../../interfaces/status";

export function Info({ status }: { status: IStatus }) {
  let img = "/assets/icons/error.svg";
  return (
    <div className={style.info}>
      <img src={img} />
      <p>{status?.message || "error occurred, please try again later"}</p>
    </div>
  );
}
